<template>
  <div style="display: inline-block;">
    <el-select v-model="value" placeholder="请选择" size="mini" @change="handleSelectChange">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'store',
    event: 'input'
  },
  props: ['store'],
  data() {
    return {
      options: [],
      value: ''
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      let {success, data} = await this.$q.preSalePlan.planGetShop();
      if(success) {
        let options = [];
        Object.keys(data).forEach(key=>{
          options.push({
            label: data[key],
            value: key
          })
        });
        this.options = options;
        this.value = options[0].value;
        this.setStoreName(options[0].label);
        this.$store.dispatch('preSalePlan/set_storeId', options[0].value);
        // if(options[0].label != '全平台') {
        //   this.handleSelectChange(options[0].value)
        // }
        this.$emit('input', this.value)
      }
    },
    setStoreName(name) {
      sessionStorage.setItem('storeName', name);
    },
    handleSelectChange(id) {
      let storeName = this.options.filter(v=>v['value'] === id)[0]['label'];
      this.setStoreName(storeName);
      this.$store.dispatch('preSalePlan/set_storeId', id);
      this.$emit('input', id)
      this.$emit('change', id)
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-select
    width 100px
</style>